import { CircularProgress } from '@mui/material';
import React from 'react';

export const DisplayMoreRow = props => {
    return (
        <tr class={props.tr_css} onClick={props.onClick}>
            <td />
            <td />
            <td />
            <td colspan="2">
                {props.loading ?
                    <CircularProgress style={{ width: '1.2rem', height: '1.2rem', borderWidth: '.1em' }} />
                    :
                    <p style={{ color: "#5b2fd4" }}>
                        {"Displaying " + props.displaying + " / " + props.total + " rows - Click to display all"}
                    </p>
                }
            </td>
            <td />
        </tr>
    )
}